import { render, staticRenderFns } from "./About-comp.vue?vue&type=template&id=61ff1608&scoped=true&"
import script from "./About-comp.vue?vue&type=script&lang=js&"
export * from "./About-comp.vue?vue&type=script&lang=js&"
import style0 from "./About-comp.vue?vue&type=style&index=0&id=61ff1608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff1608",
  null
  
)

export default component.exports